import { toast } from 'sonner'

interface UseBulkArchiveOptions<T> {
  selected: T[]
  getId: (item: T) => string
  archiveFn: (id: string) => Promise<unknown>
  /** Singular entity label, e.g. "invoice" → "2 invoices archived" */
  label: string
  onSuccess: (succeededIds: string[]) => void
}

export function useBulkArchive<T>({
  selected,
  getId,
  archiveFn,
  label,
  onSuccess,
}: UseBulkArchiveOptions<T>) {
  async function handleBulkArchive() {
    const ids = selected.map(getId)
    const results = await Promise.allSettled(ids.map((id) => archiveFn(id)))
    const succeededIds = ids.filter((_, index) => results[index].status === 'fulfilled')
    const failed = results.length - succeededIds.length
    if (failed > 0) {
      toast.error('Some archives failed', {
        description: `${succeededIds.length} archived, ${failed} failed.`,
      })
    } else {
      toast.success(
        `${succeededIds.length} ${label}${succeededIds.length === 1 ? '' : 's'} archived`,
      )
    }
    if (succeededIds.length > 0) {
      onSuccess(succeededIds)
    }
  }

  return { handleBulkArchive }
}
